import React from 'react'
export const PopupLink: React.FC<{
  href: string
  children: React.ReactNode
}> = ({ href, children }) => (
  <a href={href} target="_blank">
    {children}
  </a>
)
